// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureStatistics_container__2d0VQ","statsContainer":"FeatureStatistics_statsContainer__unat6"};